<template>
  <div class="infoItem">
    <ul class="news-content">
      <li class="lis"
          @click="goDetail(itemDada)">
        <div class="item_info">
          <img class="avatar"
               :src="itemDada.avatar" />
          <div class="title">
            <span class="name">{{itemDada.nickname}}</span>
            <span class="desc">{{itemDada.created_at}}</span>
          </div>
        </div>
        <slot class="top_right_icon"
              name="right-icon"></slot>
        <slot name="detail"></slot>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "infoItem",
  props: {
    itemDada: {
      type: Object,
      default: {}
    }
  },
  data () {
    return {
    };
  },
  created () {
  },
  methods: {
    goDetail (item) {
      this.$emit('goDetail', item)
    }
  }
};
</script>

<style lang="scss" scoped>
.infoItem {
  // @extend %default-bg;
  background-color: #fff;
  .news-content {
    padding: 0 30px;
    li {
      padding: 20px;
      background: #fff;
      .item_content {
        margin-left: 66px;
        .que_title {
          font-size: 26px;
          color: #333333;
          line-height: 32px;
        }
        .ans_conten {
          margin-top: 10px;
          color: #7c7c7c;
          font-size: 24px;
          line-height: 33px;
          @include lines-eps(3);
        }
      }
      .avatar {
        display: block;
        width: 50px;
        height: 50px;
        border-radius: 50%;
        flex: none;
        margin-right: 16px;
        float: left;
      }
      .img_items {
        margin: 20px 0;
        display: flex;
        justify-content: space-between;
        .img_item {
          width: 160px;
          height: 160px;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }

      .title {
        float: left;
        padding-top: 4px;
      }
      & > div {
        overflow: hidden;
        .name {
          @include eps;
          font-size: 28px;
          font-weight: 500;
          color: #333;
          display: block;
        }
        .desc {
          @include eps;
          font-size: 22px;
          color: #999;
          float: left;
          margin-top: 10px;
        }
        .top_right_icon {
          float: right;
          margin-top: -10px;
          .icon_span {
            font-size: 22px;
            color: #999;
            line-height: 22px;
            margin: 0 10px;
            display: inline-block;
          }
          .number {
            padding: 0 0 0 34px;
            background: url("~@/assets/images/icon-eye.png") left center
              no-repeat;
            background-size: 25px 17px;
          }
        }
      }
    }
    li:nth-last-child(1) {
      border-bottom: none;
    }
  }
}
</style>
